import styled from 'styled-components';
import { Icon } from '@blueprintjs/core';
import ThumbnailWithStatelems from '../../services/thumbnailer/thumbnail-with-statelems';

const Wrapper = styled.div`
  position: relative;
  background: var(--light-blue);
  // margin-bottom: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  padding-top: ${(props) => (props.showPadding ? '62.5%' : '0')};
`;

const ThumbnailWithStatelemsPlaceholderImage = ({
  thumb,
  width,
  height,
}) => {
  return (
    <Wrapper showPadding={!thumb} width={width} height={height}>
      {thumb && (
        <ThumbnailWithStatelems
          thumbnail={thumb}
        />
      )}
    </Wrapper>
  );
};

export default ThumbnailWithStatelemsPlaceholderImage;
